import React from "react";

const BASE_CONTAINER_CLASSES =
    "mx-auto w-full max-w-[1500px] px-4 sm:px-6 lg:px-8 xl:px-10";

const PageContainer = ({
    as: Component = "div",
    className = "",
    children,
    ...props
}) => (
    <Component
        className={`${BASE_CONTAINER_CLASSES}${className ? ` ${className}` : ""}`}
        {...props}
    >
        {children}
    </Component>
);

export default PageContainer;
